import React from 'react';
import Img from '../components/image'


function Button(props) {
    return (
        <a href={props.link} target={props.target} type="button" className="button">{props.text}<span><img src={props.source} alt="" /></span></a>
    )
}

export default Button;